import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mhc_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_senior-care-support/artifacts/4md4h4us_1790164502595_qtmuiq.webp";
